<div
  class="tw-flex tw-items-center tw-justify-center"
  [ngClass]="
    large
      ? 'card-selected-tile tw-h-9 tw-w-9 tw-rounded-[10px] tw-bg-dt-surface-elevated'
      : useManageAccountStyle
        ? 'card-selected-tile tw-h-8 tw-w-8 tw-rounded-lg tw-bg-dt-surface-elevated'
        : 'tw-h-full tw-rounded-full tw-bg-dt-surface-sunken'
  "
>
  <div
    class="tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
    [ngClass]="large ? 'tw-h-[26px] tw-w-[26px] tw-rounded-md' : 'tw-h-5 tw-w-5 tw-rounded-full'"
  >
    @if (square_logo_url && square_logo_url !== "") {
      <img
        [ngSrc]="square_logo_url"
        width="200"
        height="200"
        class="tw-w-auto tw-h-auto tw-object-contain"
        alt="icon"
      />
    } @else {
      <icon [name]="icon" [size]="5" [currentColor]="'dt-indigo-9'"></icon>
    }
  </div>
</div>
